import { ReactNode, createContext, useContext } from 'react';
import { BridgeKycInfoData } from 'services/merchants/types';

const BridgeKycInfoContext = createContext<BridgeKycInfoData | null | undefined>(undefined);

interface BridgeKycInfoProviderProps {
  children: ReactNode;
  value: BridgeKycInfoData | null | undefined;
}

export const BridgeKycInfoProvider = ({ children, value }: BridgeKycInfoProviderProps) => (
  <BridgeKycInfoContext.Provider value={value}>{children}</BridgeKycInfoContext.Provider>
);

export const useBridgeKycInfoContext = () => useContext(BridgeKycInfoContext);
